module.exports = __webpack_public_path__ + "img/store.4e3ded1c.svg";